type GetAnimalAgeDetailsProps = {
  age_in_months?: boolean;
  age: number;
  time_period_type?: 'short' | 'full';
};

export const getAnimalAgeDetails = ({ age_in_months, age, time_period_type = 'short' }: GetAnimalAgeDetailsProps) => {
  const time_periods = {
    full: `${age_in_months ? (age > 1 ? 'months' : 'month') : age > 1 ? 'years' : 'year'} old`,
    short: `${age_in_months ? (age > 1 ? 'mo' : 'mo') : age > 1 ? 'yrs' : 'yr'}`,
  };

  const ageDetails = `${age}${time_period_type === 'full' ? ` ${time_periods[time_period_type]}` : time_periods[time_period_type]}`;
  return ageDetails;
};
